import React, { useEffect, useRef, useState } from 'react';
import ComPatSearch from './ComPatSearch';
import ComTemplateSave from './ComTemplateSave';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import SearchStaffUser from '../../Utilities/SerchStafUser';
import ComGrpSearchSpan from './ComGrpSearchSpan';
import { useSelector } from 'react-redux';

function ComPatientComposeText({ close, handleReload, userPat }) {
  const inputRef = useRef();
  const { user } = useSelector((state) => state.auth);
  const [selectedPats, setSelectedPats] = useState([]);
  const [taggedStaff, setTaggedStaff] = useState([]);
  const [tempMsgString, setTempMsgString] = useState('');

  const [serchTemplet, setSerchTemplet] = useState('');
  const [tampletList, setTampletList] = useState([]);
  const [tempPopup, setTempPopup] = useState(false);

  const [isDivHidden, setIsDivHidden] = useState(false);

  const defComPat = userPat
    ? {
        userId: userPat.user_id,
        passPaientNameInJsFun: userPat.patName,
        dob: userPat.dob,
        age: userPat.age,
        gender: userPat.gender,
        chart_number: userPat.chart_number,
        mobile: userPat.mobile,
        email: userPat.email,
      }
    : '';

  useEffect(() => {
    const getTemplet = async () => {
      try {
        const response = await post(
          'api/communication/Communication/templateForText',
          {}
        );
        if (response.status === 200) {
          setTampletList(response?.data?.allShortMsg);
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      }
    };
    getTemplet();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef?.current.contains(event.target)) {
        setIsDivHidden(true);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [inputRef]);

  const handleMsg = (text) => {
    setTempMsgString(text);
    setSerchTemplet('');
    setIsDivHidden(true);
  };

  const handleSendTextMsg = async () => {
    if (!tempMsgString) {
      setUiMessage('err', 'Please wrire some mesage.');
    } else if (!selectedPats) {
      setUiMessage('err', 'Please select to paient.');
    } else {
      try {
        const response = await post('api/communication/Communication/sendSms', {
          to: selectedPats,
          message: tempMsgString,
          tagStaff: taggedStaff.map((item) => item.staff_id).join(','),
          loginUserId: user?.id,
        });
        if (response?.status === 200) {
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Message sent successfully.');
            handleReload();
            close();
          } else if (response?.data?.status === 'fail') {
            setUiMessage('err', 'Message not sent.');
          } else {
            setUiMessage('err', response?.data?.status);
          }
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    }
  };

  const filteredData =
    tampletList.length > 0 &&
    tampletList.filter((item) =>
      item.template_msg.toLowerCase().includes(serchTemplet.toLowerCase())
    );

  return (
    <>
      <div className="modalBackground">
        <div className="compose-msg-main-con grid-sec tab-bg">
          <div className="comp-msg-hdr flex-sec">New Text (Patient)</div>
          <div className="comp-msg-bdy grid-sec">
            <div className="comp-msg-bdy-rw flex-sec orange-txt">
              <i>
                Do not include PHI; select Secure Message sent over the Patient
                Portal for PHI
              </i>
            </div>
            <ComPatSearch
              defaultPat={defComPat ? [defComPat] : undefined}
              msgType={'mobile'}
              bigSearchBox={true}
              fieldName={'To'}
              changeShow={false}
              handlePatArr={(selectedPats) => setSelectedPats(selectedPats)}
              returntype={'str'}
            />
            <ComGrpSearchSpan
              handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
            />
            <SearchStaffUser
              fieldName={'Tag Staff'}
              key={Math.random()} // Ensure re-rendering when the key changes
              tagStaffUser={taggedStaff}
              handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
            />
            <div
              ref={inputRef}
              className="comp-msg-bdy-rw grid-sec"
              style={{ position: 'relative' }}
            >
              <div className="comp-msg-bdy-chld-rw flex-sec">
                <span className="msg-bdy-rw-bl">Template:</span>
                <span className="msg-bdy-rw-val">
                  <input
                    type="text"
                    className="msg-inpt"
                    placeholder="Select the template from the list..."
                    onChange={(e) => {
                      setSerchTemplet(e.target.value);
                      e.target.value.length > 0
                        ? setIsDivHidden(false)
                        : setIsDivHidden(true);
                    }}
                    style={{ width: '92%' }}
                    value={serchTemplet}
                  />
                  <span
                    className="add-nw-tmplt"
                    onClick={() => setTempPopup(true)}
                  >
                    +
                  </span>
                </span>
                <div
                  className={`search-user-pnl grid-sec ${
                    isDivHidden ? 'hide' : ''
                  }`}
                >
                  {filteredData &&
                    filteredData.map((item, i) => {
                      return (
                        <div key={i}>
                          <span
                            className="usr-name grid-sec"
                            data-search-term={item?.template_msg}
                            onClick={(e) => handleMsg(e.target.textContent)}
                          >
                            {item?.template_msg}
                          </span>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="comp-msg-bdy-rw flex-sec">
              <span className="msg-bdy-rw-bl">Message:</span>
              <span className="msg-bdy-rw-val">
                <textarea
                  className="msg-bdy"
                  placeholder="Write your Message here"
                  onChange={(e) => setTempMsgString(e.target.value)}
                  value={tempMsgString}
                ></textarea>
              </span>
            </div>
          </div>
          <div className="comp-msg-ftr flex-sec">
            <button className="actn-yes" onClick={handleSendTextMsg}>
              Send
            </button>
            <button className="actn-No" onClick={close}>
              Cancel
            </button>
          </div>
        </div>
        {tempPopup && (
          <ComTemplateSave
            templateArr={tampletList}
            setTemplateArr={(data) => setTampletList(data)}
            close={() => setTempPopup(false)}
          />
        )}
      </div>
    </>
  );
}

export default ComPatientComposeText;
